module.exports = __webpack_public_path__ + "static/media/lawsuit-free-hold.e746c5d2.mp3";